import { Directive } from '@angular/core';

/** Legacy `date-picker` attribute compatibility (pickadate is initialized via global scripts on `.pickadate`). */
@Directive({
  selector: '[appDatePicker]',
  standalone: true,
})
export class DatePickerDirective {}
